import { render, staticRenderFns } from "./articulos_web.vue?vue&type=template&id=020e0231&"
import script from "./articulos_web.vue?vue&type=script&lang=js&"
export * from "./articulos_web.vue?vue&type=script&lang=js&"
import style0 from "./articulos_web.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports